module.exports = __webpack_public_path__ + "img/pysct.feee6788.png";